<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M1799.16 1318.07c-265.58,0 -481.03,215.45 -481.03,481.09 0,265.58 215.45,481.03 481.03,481.03 265.64,0 481.09,-215.45 481.09,-481.03 0,-265.64 -215.45,-481.09 -481.09,-481.09l0 0zm0 1282.85c-442.67,-0.06 -801.7,-359.09 -801.7,-801.76 0,-442.73 359.03,-801.76 801.7,-801.76 442.73,0 801.76,359.03 801.76,801.76 0,442.67 -359.03,801.7 -801.76,801.7l0 0.06zm0 -2004.43c-801.76,0 -1486.49,498.73 -1763.89,1202.67 277.4,703.94 962.13,1202.67 1763.89,1202.67 801.76,0 1486.49,-498.73 1763.89,-1202.67 -277.4,-703.94 -962.13,-1202.67 -1763.89,-1202.67z"/> 
 </g>
 </g>
</svg>
